const CONFIG = window.config || { REQUEST_TIMEOUT: 25000 };

function urlPath(url) {
  const lowerUrl = url.toLowerCase();
  let skip = 0;
  if (lowerUrl.startsWith('https://')) skip = 8;
  if (lowerUrl.startsWith('http://')) skip = 7;
  const start = lowerUrl.indexOf('/', skip);
  let end = lowerUrl.indexOf('?', skip);
  if (end === -1) end = url.length;
  return lowerUrl.slice(start, end);
}

export const fetchFn = (() => {
  const seconds = Math.floor(CONFIG.REQUEST_TIMEOUT / 1000);
  return (url, options) => {
    const error = new Error(
      `Timeout: Server failed to respond in ${seconds}s: ${urlPath(url)}`,
    );
    return fetch(
      url,
      { ...options, signal: AbortSignal.timeout(CONFIG.REQUEST_TIMEOUT) },
      error,
    );
  };
})();

export const getFetch = (endPoint) =>
  fetchFn(endPoint, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Pragma: 'no-cache',
    },
  });

export const postFetch = (endPoint, body) =>
  fetchFn(endPoint, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
    },
    body: JSON.stringify(body),
  });

export const putFetch = (endPoint, body) =>
  fetchFn(endPoint, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
    },
    body: JSON.stringify(body),
  });

export const deleteFetch = (endPoint, body) =>
  fetchFn(endPoint, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Pragma: 'no-cache',
      ...(body && { 'Content-Type': 'application/json' }),
    },
    ...(body && { body: JSON.stringify(body) }),
  });
